
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ThreeStepProcessSection from './components/ThreeStepProcessSection';
import SpeedConvenienceSection from './components/SpeedConvenienceSection';
import LandValueSection from './components/LandValueSection';
import TopographySection from './components/TopographySection';
import UtilityAccessSection from './components/UtilityAccessSection';
import ZoningSection from './components/ZoningSection';
import GeographicSection from './components/GeographicSection';
import TargetAreasSection from './components/TargetAreasSection';
import RuralUrbanSection from './components/RuralUrbanSection';
import HoldingCostsSection from './components/HoldingCostsSection';
import TaxLiensSection from './components/TaxLiensSection';
import InheritedLandSection from './components/InheritedLandSection';
import DivorceRelocationSection from './components/DivorceRelocationSection';
import MarketTrendsSection from './components/MarketTrendsSection';
import ComparisonTableSection from './components/ComparisonTableSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function LandBuyersPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell Land Fast El Paso | We Buy Vacant Land for Cash | TREX RE LLC"
        description="Sell your vacant land fast for cash in El Paso. We buy all types of land - raw, undeveloped, inherited, or with tax liens. No commissions, fast closing. Get your cash offer today."
        keywords="sell land fast El Paso, cash land buyers Texas, sell vacant land, we buy land El Paso, land investors Texas"
        canonical="/land-buyers"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Land Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <ThreeStepProcessSection />
      <SpeedConvenienceSection />
      <LandValueSection />
      <TopographySection />
      <UtilityAccessSection />
      <ZoningSection />
      <GeographicSection />
      <TargetAreasSection />
      <RuralUrbanSection />
      <HoldingCostsSection />
      <TaxLiensSection />
      <InheritedLandSection />
      <DivorceRelocationSection />
      <MarketTrendsSection />
      <ComparisonTableSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
